import React from 'react';
import './StaticPage.css';

const Datenschutz = ({ onBack }) => {
    return (
        <div className="static-page">
            <div className="static-content">
                <div className="static-header">
                    <img
                        src={`${process.env.PUBLIC_URL}/main.png`}
                        alt="SRR Logo"
                        className="static-logo"
                    />
                    <div className="static-title">
                        <span className="static-title-top">Simple</span>
                        <span className="static-title-bottom">RefiReg</span>
                    </div>
                </div>

                <div className="static-text-container">
                    <h1>Datenschutzerklärung</h1>

                    <h2>1. Allgemeine Informationen</h2>
                    <p>
                        In der folgenden Datenschutzerklärung informieren wir Sie detailliert über Umgang mit Ihrer personenbezogenen Daten, die wir erfassen und verarbeiten, wenn Sie unsere Website besuchen.
                        Sowie die damit verbundenen Zwecke und den Umfang der Verarbeitung.
                    </p>

                    <h2>2. Verantwortlicher</h2>
                    <p>
                        <strong className="company-name">sstyle.org</strong><br />
                        <span className="company-slogan">it (re)engineering</span>
                        <span className="company-owner">Inhaber: Max Becker</span>
                        <br />
                        Hubertusstr. 27c<br />
                        15537 Grünheide (Mark)<br />
                        <br />
                        E-Mail: info@sstyle.org<br />
                        Tel: &nbsp;+49 3362 888 422 8<br />
                        Fax: +49 3362 888 422 9<br />
                        <br />
                        Falls Sie Fragen oder Anliegen bezüglich der Datenverarbeitung haben, können Sie sich an uns wenden.
                    </p>

                    <h2>3. Zwecke der Datenverarbeitung</h2>
                    <p>
                        Wir verarbeiten Ihre Daten, um die Nutzung der Website zu ermöglichen, Ihre Anfragen zu beantworten und unsere Dienstleistungen zu optimieren. Dazu gehören:
                    </p>
                    <ul>
                        <li>Bereitstellung der Website und deren Funktionen</li>
                        <li>Analyse der Nutzung (z. B. durch Cookies oder Webanalysen)</li>
                        <li>Kommunikation mit Ihnen (z. B. bei Anfragen oder Support)</li>
                    </ul>
                    <p>
                        Die Verarbeitung erfolgt auf Grundlage der Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), zur Erfüllung von Vertragsverpflichtungen (Art. 6 Abs. 1 lit. b DSGVO) oder aufgrund berechtigter Interessen (Art. 6 Abs. 1 lit. f DSGVO).
                    </p>

                    <h2>4. Arten der verarbeiteten Daten</h2>
                    <p>
                        Beim Besuch unserer Website werden bestimmte Daten automatisch oder durch Ihre Eingaben erhoben und verarbeitet.
                    </p>

                    <h3>4.1 Personenbezogene Daten</h3>
                    <p>
                        Personenbezogene Daten sind Daten, die sich auf eine natürliche Person beziehen und deren Identität direkt oder indirekt erkennen lassen.
                    </p>
                    <p>
                        Es ist ausdrücklich nicht vorgesehen, im Demo‑System echte personenbezogene Daten einzugeben. Jegliche durch Nutzer eingegebenen Daten gelten als Testdaten.
                    </p>

                    <h3>4.2 Zugriffsdaten (Serverlogs)</h3>
                    <p>
                        Zugriffsdaten sind technische Informationen, die Ihr Browser an unseren Server übermittelt. Diese Daten werden automatisch gespeichert und dienen der technischen Analyse sowie der Sicherstellung der Funktionalität unserer Website.
                        Die folgenden Daten werden erhoben:
                    </p>
                    <ul>
                        <li>Browsertyp und -version (z. B. Chrome, Firefox, Safari)</li>
                        <li>Betriebssystem (z. B. Windows, macOS, Android)</li>
                        <li>Hostname des zugreifenden Rechners</li>
                        <li>Datum und Uhrzeit der Serveranfrage</li>
                        <li>IP-Adresse</li>
                    </ul>
                    <p>
                        Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO, da wir ein berechtigtes Interesse an der Sicherstellung der Stabilität, Funktionalität und Sicherheit unserer Website sowie an der Analyse technischer Zugriffsdaten haben.
                    </p>

                    <h2>5. Datenverarbeitung durch Drittanbieter</h2>
                    <p>
                        Eine Übermittlung der Daten an Dritte findet grundsätzlich nicht statt, außer in folgenden Fällen:
                    </p>
                    <ul>
                        <li>eine gesetzliche Verpflichtung besteht</li>
                        <li>die Weitergabe zur Durchsetzung unserer Rechte erforderlich ist</li>
                    </ul>

                    <h2>6. Speicherung und Löschung</h2>
                    <h3>6.1 Demo‑Nutzungsdaten</h3>
                    <ul>
                        <li>Können jederzeit gelöscht werden.</li>
                        <li>Werden spätestens nach 30 Tagen automatisch entfernt (oder sofort, wenn das Demo‑System zurückgesetzt wird).</li>
                    </ul>
                    <h3>6.2 Server‑Logs</h3>
                    <p>
                        Werden aus Sicherheitsgründen bis zu 30 Tage aufbewahrt und danach automatisch gelöscht.
                    </p>

                    <h2>7. Cookies</h2>
                    <p>
                        Wir verwenden Cookies, um den Besuch unserer Website nutzerfreundlich zu gestalten und die Nutzung bestimmter Funktionen zu ermöglichen.
                    </p>
                    <p>
                        Notwendige Cookies, die für die Durchführung der elektronischen Kommunikation oder zur Bereitstellung der von Ihnen gewünschten Funktionen erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. Unser berechtigtes Interesse liegt in der technisch fehlerfreien und optimierten Bereitstellung unserer Dienste.
                    </p>
                    <p>
                        Weitere, nicht zwingend erforderliche Cookies – beispielsweise zur Analyse Ihres Surfverhaltens – werden nicht eingesetzt.
                    </p>

                    <h2>8. Datensicherheit</h2>
                    <p>
                        Wir setzen angemessene technische und organisatorische Maßnahmen ein, um Ihre Daten vor unbefugtem Zugriff, Verlust oder Zerstörung zu schützen. Unsere Sicherheitsmaßnahmen werden regelmäßig überprüft und entsprechend der technologischen Entwicklung angepasst.
                    </p>

                    <h2>9. Änderungen dieser Datenschutzerklärung</h2>
                    <p>
                        Wir empfehlen Ihnen, sich regelmäßig über den Inhalt unserer Datenschutzerklärung zu informieren. Diese wird angepasst, sobald Änderungen der von uns vorgenommenen Datenverarbeitungen dies erforderlich machen. Sofern durch eine Aktualisierung eine Mitwirkung Ihrerseits (z. B. eine Einwilligung) oder eine individuelle Benachrichtigung erforderlich wird, informieren wir Sie gesondert.
                    </p>
                </div>

                <button
                    className="static-back-link"
                    onClick={onBack}
                >
                    Zurück
                </button>
            </div>
        </div>
    );
};

export default Datenschutz;


